import { MedicalTechnologyConfig } from '@app/icare/entities/medicalTechnology/config'
import { patientMedicalTechnologyQueries } from '@app/icare/entities/medicalTechnology/queries/patientMedicalTechnologyQueries'
import { PatientMedicalTechnologyEditDrawer } from '@app/icare/entities/patient/edits/PatientMedicalTechnologyEditDrawer'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import type { PatientMedicalTechnologyRelation } from '@app/icare/entities/patient/schema/PatientMedicalTechnology'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientMedicalTechnologyQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: items = [] } = useSuspenseQuery(patientMedicalTechnologyQueries.forIndex(id))
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientMedicalTechnologyRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/medizintechnikversorger/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })

  return (
    <RelationOverview
      items={items}
      labels={MedicalTechnologyConfig}
      findings={{}}
      basePath={`/patienten/${id}/medizintechnikversorger`}
      onEdit={params =>
        void PatientMedicalTechnologyEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
    />
  )
}
